<div class="centering-div">
  <mat-card appearance="outlined" class="presentation-card" [routerLink]="[detailUrl]">
    <span class="material-icons {{footerCssClass}}">
      {{icon}}
    </span>
    <mat-card-content>
      <div class="centering-div">
        <span class="counter-pic">
          {{counter}}
        </span>
      </div>
      <span class="description">
        {{description}}
      </span>
    </mat-card-content>
    <mat-card-actions fxLayout="row" fxLayoutAlign="center" class="footer">
      <button mat-stroked-button fxFlex class="btnNavBar" (click)="$event.stopPropagation();btnClick();">
        Consulter
      </button>
    </mat-card-actions>
  </mat-card>
</div>
